import { ProductSpecsAkbModal, ProductSpecsDisksModal, ProductSpecsTyresModal } from '../const/ArraySpecModal';
import { Part, PartProduct, ProductSpecCode } from '../types/productSchema';

export const isModal = (part: Part | PartProduct, value: ProductSpecCode): boolean => {
  switch (part) {
    case Part.Tyres:
    case Part.TruckTires:
    case Part.MotoTires:
    case PartProduct.Tyres:
    case PartProduct.TruckTires:
    case PartProduct.MotoTires:
      return ProductSpecsTyresModal.includes(value);
    case Part.Disks:
    case PartProduct.Disks:
      return ProductSpecsDisksModal.includes(value);
    case Part.Batteries:
    case PartProduct.Batteries:
      return ProductSpecsAkbModal.includes(value);
    default:
      return false;
  }
};
